

type ListenerInterface = (e: Event) => void;
type ListenerList = ListenerInterface[];

const boundEventByElement = new Map<Element, Map<string, ListenerList>>();

export function elementAddEvent(element: Element, type: string, listener: ListenerInterface) {
    let elementMap = boundEventByElement.get(element);
    if (!elementMap) {
        elementMap = new Map();
        boundEventByElement.set(element, elementMap);
    }
    let items: ((e: Event) => void)[] = [];
    if (!elementMap.has(type)) {
        elementMap.set(type, items);
    } else {
        items = elementMap.get(type) as ListenerList ;
    }

    items.push(listener);
    element.addEventListener(type, listener);
}

export function elementRemoveAllEvent(element: Element, type: string) {
    const elementMap = boundEventByElement.get(element);
    if (!elementMap) {
        return;
    }
    elementMap.get(type)?.forEach(listener => element.removeEventListener(type, listener));
}

export function elementRemoveAllEventAndAdd(element: Element, type: string, listener: ListenerInterface) {
    elementRemoveAllEvent(element, type);
    elementAddEvent(element, type, listener);
}